import React from "react";
import SectionHeader from "./SectionHeader";
import { openEngineData } from "../../utils/constant";

const { comparisonItems, coparisonGraphs } = openEngineData.benchmarks;

const Benchmarks = () => {
  return (
    <div className="open-engine-benchmarks">
      <SectionHeader
        subtitle="Benchmarks"
        title="Creating the perfect balance of Cost & Performance"
      />
      <div className="comparison-items">
        {comparisonItems.map((comparisonItem, index) => (
          <div key={index} className="comparison-item">
            <h4 className={`title ${comparisonItem.textColor}`}>
              {comparisonItem.title}
            </h4>
            <div className="content">
              <p className="desc">{comparisonItem.description}</p>
              <img
                className="img"
                src={comparisonItem.images}
                alt={comparisonItem.title}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="comparison-graphs">
        {coparisonGraphs.map((coparisonGraph, index) => (
          <img
            src={coparisonGraph.image}
            key={index}
            alt=""
            className="comparison-graph"
          />
        ))}
      </div>
    </div>
  );
};

export default Benchmarks;
